export const POSITION_CARD_ONE = [
  {
    from: {},
    to: { x: 30, y: 0, rotate: '-10deg' },
  },
  {
    from: {},
    to: [
      { x: 300, y: -320, rotate: '50deg' },
      { x: 500, y: -280 },
    ],
  },
  {
    from: {},
    to: [{ x: 30, y: -150, rotate: '-10deg' }, { x: 400 }],
  },
  {
    from: {},
    to: [{ x: 25, y: -150, rotate: '-10deg' }, { x: 400 }],
  },
];

export const POSITION_CARD_TWO = [
  {
    from: {},
    to: { x: 0, y: -25, rotate: '0deg' },
  },
  {
    from: {},
    to: [{ x: 27, y: -50, rotate: '-35deg' }, { x: 500 }],
  },
  {
    from: {},
    to: [{ x: 190, y: -320, rotate: '20deg' }, { x: 500 }],
  },
  {
    from: {},
    to: [{ x: 70, y: -50, rotate: '-35deg' }, { x: 500 }],
  },
];

export const POSITION_CARD_THREE = [
  {
    from: {},
    to: { x: -30, y: 0, rotate: '10deg' },
  },
  {
    from: {},
    to: [{ x: -22, y: -144, rotate: '10deg' }, { x: 500 }],
  },
  {
    from: {},
    to: [{ x: 0, y: -50, rotate: '10deg' }, { x: 400 }],
  },
  {
    from: {},
    to: [{ x: 30, y: -320, rotate: '10deg' }, { x: 200 }],
  },
];
